<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="lessons"
      :items-per-page="50"
      class="elevation-1"
      :search="search"
    >
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "Lecturers",

  data: () => ({
    drawer: null,
    headers: [
      { text: "Code", value: "code"},
      { text: "Nom", value: "name" },
    ],
    lessons: [],
    search: null,
  }),
  methods: {
    loadLessons() {
      this.axios
        .get("/lessons", {params: {}})
        .then((response) => (this.lessons = response["data"]));
    },
  },
  mounted() {
    this.loadLessons();
  },
};
</script>